import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { AuthenticationReducer } from '../../lib/PST.Web.Common/src/services/authentication/base';
import { CategoriesReducer } from '../../lib/PST.Web.Common/src/services/categories/categoriesReducer';
import { FormationTypeReducer } from '../../lib/PST.Web.Common/src/services/formationTypes/categoriesReducer';
import { I18nReducer } from '../../lib/PST.Web.Common/src/services/i18n/reducer';
import { ProfileReducer } from '../profile/profileReducer';
import { QuizReducer } from '../quiz/quizReducer';

const rawAppReducer = combineReducers({
    i18n: I18nReducer,
    Authentication: AuthenticationReducer,
    Categories: CategoriesReducer,
    FormationTypes: FormationTypeReducer,
    Profile: ProfileReducer,
    Quiz: QuizReducer,
});

const ApplicationReducer = persistReducer(
    {
        key: 'pst-front-office-root',
        whitelist: ['Authentication', 'Profile', 'Quiz'],
        storage,
    },
    rawAppReducer,
);

export { ApplicationReducer, rawAppReducer };
